import { render } from "./ProjectDashboard.vue?vue&type=template&id=9064edf8&scoped=true"
import script from "./project_dashboard.js?vue&type=script&lang=js&external"
export * from "./project_dashboard.js?vue&type=script&lang=js&external"

import "./ProjectDashboard.vue?vue&type=style&index=0&id=9064edf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9064edf8"]])

export default __exports__